// extracted by mini-css-extract-plugin
module.exports =  {"folder":"_33974c2b58--folder--dHNi9","text":"_33974c2b58--text--nlEqt"};